<template>
  <bl-section-mv class="sigil-header">
    <header class="c-header-v2" data-no-turbolink>
      <!--top header-->
      <div class="sigil-header__eyebrow">
        <bl-container-mv>
          <bl-flex-container-mv
            justify-content="space-between"
            align-items="center"
          >
            <!-- left -->
            <bl-flex-item-av>
              <bl-flex-container-mv>
                <bl-text-av
                  class="mr-12"
                  tag="span"
                  variation="body-small"
                  is-subdued
                  :is-bolder="true"
                >
                  <bl-link-av
                    href="/mobile-apps?from=nav_header"
                    is-hide-underline
                  >
                    Download app
                  </bl-link-av>
                </bl-text-av>
                <bl-text-av
                  class="mh-12"
                  tag="span"
                  variation="body-small"
                  is-subdued
                  :is-bolder="true"
                >
                  <bl-link-av :href="mitraUrl" is-hide-underline>
                    Jadi Mitra
                  </bl-link-av>
                </bl-text-av>
                <bl-text-av
                  class="mh-12"
                  tag="span"
                  variation="body-small"
                  is-subdued
                  :is-bolder="true"
                >
                  <bl-link-av :href="bukabantuanUrl" is-hide-underline>
                    BukaBantuan
                  </bl-link-av>
                </bl-text-av>
              </bl-flex-container-mv>
            </bl-flex-item-av>
          </bl-flex-container-mv>
        </bl-container-mv>
      </div>
      <bl-separator-av />
      <!-- main header -->
      <div class="sigil-header__main-nav-bar">
        <bl-container-mv>
          <bl-flex-container-mv
            justify-content="space-between"
            align-items="center"
          >
            <bl-flex-item-av class="sigil-header--revamp">
              <bl-flex-container-mv align-items="center">
                <bl-flex-item-av class="mr-24">
                  <a href="/">
                    <img
                      :src="assetUrl('bukalapak-logo-icon.svg')"
                      alt="logo bukalapak"
                      class="sigil-logo-icon"
                      style="height: 32px; width: 32px"
                    />
                    <img
                      :src="assetUrl('bukalapak-logo-primary.svg')"
                      alt="logo bukalapak"
                      class="sigil-logo-full"
                      style="height: 20px; width: auto"
                    />
                  </a>
                </bl-flex-item-av>
              </bl-flex-container-mv>
            </bl-flex-item-av>
            <bl-flex-item-av>
              <client-only v-if="isLoggedIn">
                <bl-flex-container-mv align-items="center">
                  <!-- profile -->
                  <ProfileMenu :href="`/my_lapak?${defaultParamsString}`" />
                </bl-flex-container-mv>
              </client-only>
              <bl-flex-container-mv v-else align-items="center">
                <!-- register -->
                <bl-link-av
                  :href="registerUrl"
                  is-hide-underline
                  class="pr-4 sigil-header__nav"
                  rel="nofollow"
                >
                  <bl-text-av
                    variation="body-small"
                    :is-bolder="true"
                    class="pr-4 sigil-header__nav-action"
                    >Daftar</bl-text-av
                  >
                </bl-link-av>

                <!-- login -->
                <a
                  :href="`/login?${defaultParamsString}&comeback=${originalUrl}&direct=1`"
                  class="sigil-header__nav te-header-login"
                  rel="nofollow"
                >
                  <bl-text-av
                    variation="body-small"
                    :is-bolder="true"
                    class="pr-4 sigil-header__nav-action"
                    >Login</bl-text-av
                  >
                </a>
              </bl-flex-container-mv>
            </bl-flex-item-av>
          </bl-flex-container-mv>
        </bl-container-mv>
      </div>
      <bl-separator-av />
    </header>
  </bl-section-mv>
</template>

<script>
import UAParser from 'ua-parser-js';
import ClientOnly from 'vue-client-only';
import BlSectionMv from '@bukalapak/bazaar-dweb/dist/components/BlSectionMv';
import BlContainerMv from '@bukalapak/bazaar-dweb/dist/components/BlContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-dweb/dist/components/BlFlexItemAv';
import BlFlexContainerMv from '@bukalapak/bazaar-dweb/dist/components/BlFlexContainerMv';
import BlTextAv from '@bukalapak/bazaar-dweb/dist/components/BlTextAv';
import BlLinkAv from '@bukalapak/bazaar-dweb/dist/components/BlLinkAv';
import BlSeparatorAv from '@bukalapak/bazaar-dweb/dist/components/BlSeparatorAv';

import eventTracker from './event-tracker';
import { runtimeEnv } from 'shared_js/runtime-parser';

import { defaultParamsString } from './param-tracker';

const ProfileMenu = () =>
  import(
    /* webpackChunkName: "login-component" */ './components/organisms/ProfileMenu'
  ).then((m) => m.default || m);

export default {
  components: {
    BlSectionMv,
    BlContainerMv,
    BlFlexItemAv,
    BlFlexContainerMv,
    BlTextAv,
    BlLinkAv,
    BlSeparatorAv,

    ProfileMenu,
    ClientOnly,
  },
  props: {
    originalUrl: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    defaultParamsString,
  }),
  computed: {
    user() {
      return typeof window !== 'undefined' ? window.USER : '';
    },
    isLoggedIn() {
      return this.user.id;
    },
    bukabantuanUrl() {
      const baseUrl =
        runtimeEnv.BUKABANTUAN_URL || 'https://bukabantuan.bukalapak.com';
      return `${baseUrl}?${this.defaultParamsString}`;
    },
    mitraUrl() {
      return runtimeEnv.SENTINEL_URL || 'https://mitra.bukalapak.com';
    },
    registerUrl() {
      const baseUrl =
        runtimeEnv.ACCOUNTS_URL || 'https://accounts.bukalapak.com';
      return `${baseUrl}/register/simple?${this.defaultParamsString}&comeback=${this.originalUrl}`;
    },
  },
  mounted() {
    eventTracker('c-header-v2', 'data-sigil-event-tracker', (target) => {
      const userId = global.USER.id;
      const userId36 = userId ? parseInt(userId).toString(36) : '';
      const internalTrackerUrl = global.blGlobal
        ? `${global.blGlobal.application.tracker_config.baseUrl}/e`
        : global.APP.internalTrackerUrl;
      const uap = new UAParser(window.navigator.userAgent);
      const browser = uap.getBrowser();
      const os = uap.getOS();
      const uaData = {
        browser: browser.name,
        browser_version: browser.version,
        td_os_type: os.name,
        td_os_ver: os.version,
        platform: 'desktop',
      };

      const data = {
        ...uaData,
        ui: userId36,
        identity: window.USER.identity, // TODO: handle empty identity
        evn: 'navbar_click',
        target,
        url: global.location.href,
        referrer_url: global.document.referrer,
      };

      if (global.navigator.sendBeacon) {
        global.navigator.sendBeacon(internalTrackerUrl, JSON.stringify(data));
      } else {
        global.Tracker.event(data);
      }
    });

    // =====
    const el = document.getElementById('ssr-header');
    if (el) el.remove();

    this.$root.appMountedCallback(this);
  },
  methods: {
    assetUrl: global.assetUrl,
  },
};
</script>
